import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import s from './Pagination.scss';

class Pagination extends React.Component {
  handlePageClick = e => {
    if (this.props.pginfo) {
      const eventTarget = e.target;
      const pageClicked = eventTarget.getAttribute('data-pageno');
      const { pginfo } = this.props;
      this.props
        .getItems(this.props.path, pginfo.pp, pageClicked)
        .then(data => {
          this.props.updateData(data.data.data);
        });
    } else {
      this.props.getMoreItems(
        this.props.type,
        this.props.lastSeenId,
        this.props.category,
      );
    }
  };

  renderPages = totalPages => {
    const pagesArray = [];
    const { pginfo } = this.props;

    for (let pageNo = 1; pageNo <= totalPages && pageNo <= 10; pageNo += 1) {
      let path;
      if (pageNo === 1) {
        path = `${this.props.path}`;
      } else {
        path = `${this.props.path}/${pageNo}`;
      }
      let activeClass = '';
      if (pageNo === parseInt(pginfo.cp, 10)) {
        activeClass = s.active; //component css is not working or rendering with this class
      }
      pagesArray.push(
        <Link className={`${s.page} ${activeClass}`} to={path} spa>
          <span key={pageNo}>{pageNo}</span>
        </Link>,
      );
    }
    return pagesArray;
  };

  render() {
    const { pginfo } = this.props;
    if (pginfo) {
      return <div className={s.pagination}>{this.renderPages(pginfo.tp)}</div>;
    }
    //const { type, lastSeenId, getMoreItems, category } = this.props;
    return (
      <div className={s.pagination}>
        <div className={s['view-more']} onClick={this.handlePageClick}>
          <span>view more</span>
        </div>
      </div>
    );
  }
}

Pagination.propTypes = {
  pginfo: PropTypes.shape({}).isRequired,
  getItems: PropTypes.func.isRequired,
  updateData: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  getMoreItems: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  lastSeenId: PropTypes.string.isRequired,
  category: PropTypes.shape({}).isRequired,
  contextParams: PropTypes.shape({}).isRequired,
};

export default Pagination;
